/**
 * @file_purpose  page for showing visitor list by current date wise
 * @author Swarnali Ghosh
 * @Date_Created 02-08-2023
 * @Date_Modified 02-08-2023
 */
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
    CButton,
    CCol,
    CDataTable,
    CRow,
    CLabel,
    CSelect,
    CInput,
    CModalBody,
} from '@coreui/react'
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom'
import Constants from 'src/Utility/Constants';
import defaultImg from "src/assets/icons/visit.png";
import { Modal } from 'react-bootstrap';
import VisitorManagementService from 'src/apis/VisitorManagementService';
import masterData from 'src/Utility/MasterData';
import logout from "../../../assets/icons/logout.png";
import logo from "../../../assets/icons/visitor_logo.png"
import Webcam from "react-webcam";

//Fields for showing in visitor list
const fields = [
    { key: 'created_on', label: "Date" },
    // { key: 'visitor_picture', label: "" },
    { key: 'visitor_name', label: "Name of Visitor" },
    { key: 'address', label: "Address" },
    { key: 'to_whom_meet', label: "To Whom Meet" },

    { key: 'phone_no', label: "Phone No" },
    { key: 'purpose', label: "Purpose" },
    { key: 'location_name', label: "Location" },
    { key: 'time_in', label: "Time In" },
    { key: 'time_out', label: "Time out" },
]

const VisitorManagement = (props) => {
    var accessToken = localStorage.getItem("visitor_manager_auth_token");
    const history = useHistory();

    //Define states
    const [loadingData, setLoadingData] = useState(true);
    const [addVisitorModal, setAddVisitorModal] = useState(false)
    const [loader, setLoader] = useState(0);
    const [submitDisable, setSubmitDisable] = useState(false);

    const [nameErrors, setNameErrors] = useState("");
    const [addressErrors, setAddressErrors] = useState("");
    const [toWhomMeetErrors, setToWhomMeetErrors] = useState("");
    const [purposeErrors, setPurposeErrors] = useState("");
    const [phoneNoErrors, setPhoneNoErrors] = useState("");
    // const [otpVerificationErrors, setOtpVerificationErrors] = useState("");
    const [checkOutModal, setCheckOutModal] = useState(false);
    const [selectedVisitorId, setSelectedVisitorId] = useState();
    const [fileViewer, setFileViewer] = useState(false);
    const [isCameraCapture, setIsCameraCapture] = useState(false);

    const [fileMimeString, setFileMimeString] = useState();

    const [state, setState] = useState({
        visitors: [],
        visitor_picture: '',
        visitor_name: '',
        visitor_address: '',
        to_whom_meet: '',
        purpose_id: '',
        other_purpose_id: '',
        phone_no: '',
        otp: '',
        visitor_picture_view: '',
        selected_visitor_name: '',
        visitor_img_file_name: ''
    })

    const [visitorPictureErrors, setVisitorPictureErrors] = useState('');

    let imageSrc = null;

    const tableRef = useRef(null);
    const inputRef = useRef(null);

    const [img, setImg] = useState(null);

    const webcamRef = React.useRef(null);

    // console.log(webcamRef)
    const [imgSrc, setImgSrc] = React.useState(null);

    const handleChange = (e) => {
        var newValue
        if (e.target.type == "checkbox") {
            const { id, checked } = e.target
            newValue = checked ? 1 : 0
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))
        }
        else {
            const { id, value } = e.target
            newValue = value
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))

        }
    }

    const capture = React.useCallback(() => {

        if (webcamRef.current == "null") {

        } else {
            navigator.mediaDevices.getUserMedia({ video: true }).then(() => { console.log('') }).catch(() => { console.log('') })
            imageSrc = webcamRef.current.getScreenshot();
            if (imageSrc) {
                setImgSrc(imageSrc);
                setImg(imageSrc);

                // Function to convert base64 to blob
                function dataURItoBlob(imageSrc) {

                    const byteString = atob(imageSrc.split(',')[1]);
                    const mimeString = imageSrc.split(',')[0].split(':')[1].split(';')[0];
                    const ab = new ArrayBuffer(byteString.length);
                    const ia = new Uint8Array(ab);
                    for (let i = 0; i < byteString.length; i++) {
                        ia[i] = byteString.charCodeAt(i);
                    }

                    setFileMimeString(mimeString)
                    return new Blob([ab], { type: mimeString });
                }
                let blob = dataURItoBlob(imageSrc)
                setIsCameraCapture(true);
                setState(prevState => ({
                    ...prevState,
                    visitor_picture: blob
                }))
            }
        }

    }, [webcamRef, setImgSrc]);

    const secondCapture = () => {

        setState(prevState => ({
            ...prevState,
            visitor_picture: ''
        }))

        setImgSrc('');
        setImg('');
        setFileMimeString('')

    }


    useEffect(() => {
        if (!accessToken) {
            localStorage.clear();
            history.push("/visitor-book")
            window.location.reload();
        }
        /**
        * @author Swarnali Ghosh
        * @Date_Created 04/02/2023
        * @Date_Modified 04/02/2023
        * @function async
        * @functionName loadVisitors
        * @functionPurpose this function gets visitor list by current date wise.
        *
        * @functionParam {payload object:created_on}
        * 
        * @functionSuccess Success status and message.
        *
        * @functionError {Boolean} error is there.
        * @functionError {String} message  Description message.
        */
        async function loadVisitors() {
            setLoader(1)
            let params = {
                created_on: new Date().toJSON().slice(0, 10),
                location_id: 0
            }
            VisitorManagementService.allVisitors(params).then(res => {
                if (res.message === "jwt expired") {
                    localStorage.clear();
                    history.push("/visitor-book")
                    window.location.reload();
                }
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {

                    setState(prevState => ({
                        ...prevState,
                        visitors: res.data,
                    }))

                    setLoader(0)
                    setLoadingData(false)
                }
                else {
                    setLoader(0)
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }).catch(error => {
                if (error.response.status === 401) {
                    setLoader(0)
                    localStorage.clear();
                    history.push("/visitor-book")
                }
            })
        }

        if (loadingData) {
            // if the result is not ready so you make the axios call
            loadVisitors()
        }

    }, [loadingData]);



    const handleChangePurposeId = (e) => {

        setState(prevState => ({
            ...prevState,
            purpose_id: e.target.value
        }))
    }

    const handleClick = () => {
        // 👇️ open file input box on click of other element
        inputRef.current.click();
    };

    /**
* @author Swarnali Ghosh
* @Date_Created 04-08-2023
* @Date_Modified 08-08-2023
* @function sync
* @functionName OtpGenerateValidateForm
* @functionPurpose this function submit otp generate data.
*
* @functionParam {payload object:phone_no}
* 
* @functionSuccess Success status and message.
*
* @functionError {Boolean} error error is there.
* @functionError {String} message  Description message.
*/

    /* Generate OTP  */
    const OtpGenerateValidateForm = (e) => {
        e.preventDefault();

        let params = JSON.stringify({
            "phone_no": state.phone_no
        })
        VisitorManagementService.generateOTP(params).then(res => {
            if (res.message === "jwt expired") {
                localStorage.clear();
                history.push("/visitor-book")
            }
            if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {

                toast.success(res.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
            else {
                toast.error(res.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch(error => {
            console.log(error);
        })
    }

    /**
* @author Swarnali Ghosh
* @Date_Created 04-08-2023
* @Date_Modified 08-08-2023
* @function sync
* @functionName OtpVerifyForm
* @functionPurpose this function for otp verify.
*
* @functionParam {payload object:otp}
* 
* @functionSuccess Success status and message.
*
* @functionError {Boolean} error error is there.
* @functionError {String} message  Description message.
*/

    const OtpVerifyForm = (e) => {
        e.preventDefault();

        let params = JSON.stringify({
            "otp": state.otp
        })
        VisitorManagementService.verifyOTP(params).then(res => {
            if (res.message === "jwt expired") {
                localStorage.clear();
                history.push("/visitor-book")
            }

            if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {

                toast.success(res.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
            else {

                toast.error(res.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch(error => {
            console.log(error);
        })
    }

    /* Validation Checking */
    const ValidateForm = (e) => {
        e.preventDefault();
        if (handleVisitorValidation()) {

            AddVisitorSubmitClick();
        }
        else {
            toast.error("Please fill all * fields !", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    }

    const handleChangeFile = (e) => {

        const imgUrl = URL.createObjectURL(e.target.files[0]);
        setImg(imgUrl);
        const { id, value } = e.target;
        setFileMimeString('')
        setIsCameraCapture(false)
        setState(prevState => ({
            ...prevState,
            [id]: e.target.files[0],
            visitor_img_file_name: e.target.files[0].name
        }))
    }

    /* For opening add visitor modal */
    const OpenAddVisitorModal = (e) => {

        setAddVisitorModal(!addVisitorModal)
    }

    var date = new Date();
    var currentTime = date.toLocaleTimeString();

    /* Validate all fields */
    const handleVisitorValidation = (e) => {

        let nameErrors, addressErrors, toWhomMeetErrors, purposeErrors, phoneNoErrors, visitorPictureErrors, otpVerificationErrors;
        let formIsValid = true;
        let specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

        // get file extension
        let file_name = state.visitor_img_file_name;
        let extension = file_name && file_name.substring(file_name.lastIndexOf('.') + 1, file_name.length);

        // visitor_picture
        if (!state.visitor_picture) {
            setVisitorPictureErrors('');
        }
        else if (!(extension == "jpeg" || extension == "jpg" || extension == "png" || fileMimeString == "image/jpeg")) {
            formIsValid = false;
            visitorPictureErrors = "Allow only jpeg,jpg,png extensions";
            setVisitorPictureErrors(visitorPictureErrors);

        } else {
            setVisitorPictureErrors('');
        }

        if (!state.visitor_name || state.visitor_name.trim() == '') {
            formIsValid = false;
            nameErrors = "Name can not be empty"
            setNameErrors(nameErrors)
        } else if (Boolean(specialChars.test(state.visitor_name))) {
            formIsValid = false;
            nameErrors = "Special character not be allowed"
            setNameErrors(nameErrors)

        } else if (/\p{Extended_Pictographic}/u.test(state.visitor_name)) {
            formIsValid = false;
            nameErrors = "Emoji not be allowed"
            setNameErrors(nameErrors)
        } else {
            setNameErrors("")
        }

        if (!state.visitor_address || state.visitor_address.trim() == '') {
            formIsValid = false;
            addressErrors = "Address can not be empty";
            setAddressErrors(addressErrors);
        } else if (/\p{Extended_Pictographic}/u.test(state.visitor_address)) {
            formIsValid = false;
            addressErrors = "Emoji not be allowed"
            setAddressErrors(addressErrors)
        } else {
            setAddressErrors("");
        }

        if (!state.to_whom_meet || state.to_whom_meet.trim() == '') {
            formIsValid = false;
            toWhomMeetErrors = "To Whom Meet can not be empty";
            setToWhomMeetErrors(toWhomMeetErrors);
        } else if (/\p{Extended_Pictographic}/u.test(state.to_whom_meet)) {
            formIsValid = false;
            toWhomMeetErrors = "Emoji not be allowed"
            setToWhomMeetErrors(toWhomMeetErrors)
        } else {
            setToWhomMeetErrors('');
        }

        if (!state.purpose_id || (state.purpose_id == "other" && (!state.other_purpose_id || state.other_purpose_id.trim() == ""))) {
            formIsValid = false;
            purposeErrors = "Purpose can not be empty";
            setPurposeErrors(purposeErrors);
        } else if (/\p{Extended_Pictographic}/u.test(state.other_purpose_id)) {
            formIsValid = false;
            purposeErrors = "Emoji not be allowed"
            setPurposeErrors(purposeErrors)
        } else {
            setPurposeErrors('');
        }

        if (!state.phone_no) {
            formIsValid = false;
            phoneNoErrors = "Phone No can not be empty";
            setPhoneNoErrors(phoneNoErrors);
        } else if (!(state.phone_no.length >= 10 && state.phone_no.length <= 15)) {
            formIsValid = false;
            phoneNoErrors = "Should be limited to 10-15 integers.";
            setPhoneNoErrors(phoneNoErrors);
        } else if (Boolean(specialChars.test(state.phone_no))) {
            formIsValid = false;
            phoneNoErrors = "Special character not be allowed"
            setPhoneNoErrors(phoneNoErrors)

        } else if (/\p{Extended_Pictographic}/u.test(state.phone_no)) {
            formIsValid = false;
            phoneNoErrors = "Emoji not be allowed"
            setPhoneNoErrors(phoneNoErrors)
        } else {
            setPhoneNoErrors('');
        }

        // if (!state.otp) {
        //     formIsValid = false;
        //     otpVerificationErrors = "OTP can not be empty";
        //     setOtpVerificationErrors(otpVerificationErrors);
        // } else {
        //     setOtpVerificationErrors('');
        // }

        return formIsValid;
    }

    const OpenCheckOutModal = (e, id) => {
        setSelectedVisitorId(id);
        setCheckOutModal(!checkOutModal);
    }



    const AddVisitorSubmitClick = (e) => {

        setSubmitDisable(true)
        //Using Formdata  
        const formData = new FormData();

        formData.append("visitor_name", state.visitor_name ? state.visitor_name : "");
        formData.append("address", state.visitor_address ? state.visitor_address : "");
        formData.append("phone_no", state.phone_no ? state.phone_no : "");

        formData.append("to_whom_meet", state.to_whom_meet ? state.to_whom_meet : "");

        if (state.purpose_id != "other") {
            formData.append("purpose", state.purpose_id ? state.purpose_id : "");
        }

        if (state.purpose_id == "other") {
            formData.append("purpose", state.other_purpose_id ? state.other_purpose_id : "");
        }

        if (isCameraCapture) {
            if (state.visitor_picture) {
                formData.append("visitor_picture", state.visitor_picture, `test.jpeg`);
            }
        } else {
            if (state.visitor_picture) {
                formData.append("visitor_picture", state.visitor_picture);
            }
        }



        let params = formData
        VisitorManagementService.addVisitors(params).then(res => {
            if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {

                setSubmitDisable(false)
                setAddVisitorModal(!addVisitorModal)
                setLoadingData(true)
                loadVisitorList()

                setState(prevState => ({
                    ...prevState,
                    visitor_picture: '',
                    visitor_name: '',
                    visitor_address: '',
                    to_whom_meet: '',
                    purpose_id: '',
                    other_purpose_id: '',
                    phone_no: '',
                }))
                setImg('')
                setNameErrors('')
                setAddressErrors('')
                setToWhomMeetErrors('')
                setPurposeErrors('')
                setPhoneNoErrors('')
                toast.success(res.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });

            }
            else {
                setSubmitDisable(false)
                toast.error(res.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch(error => {
            setSubmitDisable(false)
            console.log(error);
        })
    }


    const loadVisitorList = () => {

        setLoader(1)
        let params = {
            created_on: new Date().toJSON().slice(0, 10),
            location_id: 0
        }
        VisitorManagementService.allVisitors(params).then(res => {
            if (res.message === "jwt expired") {
                localStorage.clear();
                history.push("/visitor-book")
                window.location.reload();
            }
            if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                // setState({
                //     visitors: res.data,
                // });
                setState(prevState => ({
                    ...prevState,
                    visitors: res.data,
                }))

                setLoader(0)
                setLoadingData(false)

            }
            else {
                setLoader(0)
                toast.error(res.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch(error => {
            if (error.response.status === 401) {
                setLoader(0)
                localStorage.clear();
                history.push("/visitor-book")
            }
        })

    }



    /**
* @author Swarnali Ghosh
* @Date_Created 04/08/2023
* @Date_Modified 04/08/2023
* @function sync
* @functionName visitorTimeOutSubmitClick
* @functionPurpose this function visitor time out submit.
*
* @functionParam {payload object:visitor_id,time_out}
* 
* @functionSuccess Success status and message.
*
* @functionError {Boolean} error is there.
* @functionError {String} message  Description message.
*/
    const visitorTimeOutSubmitClick = (e) => {

        let params = JSON.stringify({
            "visitor_id": selectedVisitorId,
            "time_out": moment().format('HH:mm')
        })
        VisitorManagementService.visitorTimeOut(params).then(res => {
            if (res.message === "jwt expired") {
                localStorage.clear();
                history.push("/visitor-book")
            }

            if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {

                setLoadingData(true)
                setSelectedVisitorId('')
                setCheckOutModal(!checkOutModal)
                toast.success(res.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });

            }
            else {

                toast.error(res.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch(error => {
            console.log(error);
        })

    }

    const logoutSubmitClick = (e) => {
        window.location.reload();
        localStorage.clear();
        history.push("/visitor-book")
    }

    //Opening file details  modal
    const openFileViewerModal = (e, visitor_name, visitor_picture) => {
        setState((prevState) => ({
            ...prevState,
            selected_visitor_name: visitor_name,
            visitor_picture_view: visitor_picture,
        }));

        setFileViewer(!fileViewer);
    }

    //Closing file details  modal
    const closeFileViewerModal = () => {
        setState((prevState) => ({
            ...prevState,
            visitor_picture_view: '',
        }));
        setFileViewer(!fileViewer);
    }

    const videoConstraints = {
        facingMode: "user"
    };

    return (
        <>
            <ToastContainer />
            <header className="header_sec">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
                            <div className="visitor_hed">
                                <img src={logo} alt='' />
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-5 col-md-4 col-sm-12 d-none d-md-block"></div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-5 col-sm-9 col-9">
                            <div className="visitor_hed_rt">
                                <span className="visit_date">{moment(new Date().toJSON().slice(0, 10)).format("DD-MM-YYYY")} | <span className="visit_time">{date.toLocaleTimeString()}</span></span>

                                <span className="visiter_logout_sec" onClick={(e) => logoutSubmitClick(e)}>
                                    <img src={logout} alt='' />
                                    <span className="logout_mob">Logout</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <CRow>
                <CCol style={{ margin: "20px" }}>

                    <div className="main_visitor">
                        <div className="row">
                            <div className="col-xxl-3 col-sm-6 col-xl-3 col-lg-4 col-md-4 col-sm-8 col-9">
                                <h6 className="visit_txt_hed"> Visitor Book - <span>{moment(new Date().toJSON().slice(0, 10)).format("DD-MM-YYYY")}</span></h6>
                            </div>
                            <div className="col-xxl-7 col-xl-6 col-lg-6 col-md-5 col-sm-1 d-none d-md-block">
                                <div className="month_sec">

                                </div>
                            </div>
                            <div className="col-xxl-2 col-xl-3 col-lg-2 col-md-3 col-sm-4 col-3 visitor_add">

                                <CButton
                                    onClick={(e) => OpenAddVisitorModal(e)}
                                >Add Visitor</CButton>

                            </div>

                        </div>

                        <CRow>

                        </CRow>

                        <div className="leave_inn">
                            <div className="holiday_inn visiter_table">
                                {/* listing table for visitor list by current date wise */}
                                <CDataTable
                                    items={state.visitors}
                                    fields={fields}
                                    loading={loader ? loader : ""}
                                    noItemsViewSlot={loader ? "Loading..." : ""}
                                    scopedSlots={{

                                        'created_on': (item) => (
                                            <td>
                                                {item.created_on ? moment(item.created_on).format("DD-MM-YYYY") : "---"

                                                }
                                            </td>
                                        ),
                                        'visitor_picture': (item) => (
                                            (item.visitor_picture == null || item.visitor_picture === "") ?
                                                <td>
                                                    <img src={defaultImg} height={100} width={120} alt="img" />

                                                </td>
                                                :
                                                <td>
                                                    <img src={item.visitor_picture} height={100} width={120} alt="img" />

                                                </td>
                                        ),
                                        'visitor_name': (item) => (
                                            <td >
                                                {(item.visitor_picture == null || item.visitor_picture === "") ? <img src={defaultImg} height={100} width={120} alt="img" /> :
                                                    <img onClick={(e) => openFileViewerModal(e, item.visitor_name, item.visitor_picture)} style={{ cursor: 'pointer' }} src={item.visitor_picture} height={100} width={120} alt="img" />}
                                                {item.visitor_name ? item.visitor_name : "---"}
                                            </td>
                                        ),
                                        'time_out': (item) => (
                                            <td>
                                                {item.time_out ? item.time_out :
                                                    <CButton
                                                        className="checkout_visit " style={{ backgroundColor: "#5473FF", color: "#fff" }}

                                                        onClick={(e) => OpenCheckOutModal(e, item.visitor_id)}
                                                    >
                                                        Check out
                                                    </CButton>
                                                }
                                            </td>
                                        )

                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Export List in Excel Sheet */}
                    <table ref={tableRef} hidden>
                        <thead>
                            <tr>
                                <th>Visitor Picture</th>
                                <th>Name of Visitor</th>
                                <th>Address</th>
                                <th>To Whom Meet</th>
                                <th>Purpose</th>
                                <th>Location</th>
                                <th>Time In</th>
                                <th>Time out</th>
                            </tr>
                        </thead>
                        <tbody>
                            {state.visitors.map((visitorData, index) => (
                                <tr key={index}>
                                    <td>{visitorData.visitor_picture ? visitorData.visitor_picture : "---"}</td>
                                    <td>{visitorData.visitor_name ? visitorData.visitor_name : "---"}</td>
                                    <td>{visitorData.address ? visitorData.address : "---"}</td>
                                    <td>{visitorData.to_whom_meet ? visitorData.to_whom_meet : "---"}</td>
                                    <td>{visitorData.purpose ? visitorData.purpose : "---"}</td>
                                    <td>{visitorData.location_name ? visitorData.location_name : "---"}</td>
                                    <td>{visitorData.time_in ? visitorData.time_in : "---"}</td>
                                    <td>{visitorData.time_out ? visitorData.time_out : "---"}</td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </CCol>

                {/* add visitor modal */}

                <Modal
                    show={addVisitorModal}
                    onHide={() => {
                        setAddVisitorModal(!addVisitorModal)
                        setState(prevState => ({
                            ...prevState,
                            visitor_picture: '',
                            visitor_name: '',
                            visitor_address: '',
                            to_whom_meet: '',
                            purpose_id: '',
                            other_purpose_id: '',
                            phone_no: '',
                        }))
                        setImg('')
                        setNameErrors('')
                        setAddressErrors('')
                        setToWhomMeetErrors('')
                        setPurposeErrors('')
                        setPhoneNoErrors('')
                    }}
                    backdrop="static"
                >
                    <div className="apply_comp_sec">
                        <Modal.Header closeButton >
                            <h6 className="hed_txt">Add Visitor</h6>
                        </Modal.Header>

                        <div className="comp_inner_sec">
                            <div className="comp_off_inn">
                                <div className="row">

                                    <div className="col-md-12">


                                        <div className="visit_img_sec" style={{ display: "flex", justifyContent: "center" }}>

                                            <div className="profile_sec_pic" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

                                                {(img || state.visitor_picture) ?
                                                    <img style={{ width: "167px", height: "167px" }} src={img ? img : (state.visitor_picture && state.visitor_picture)} alt="" />
                                                    :
                                                    <Webcam className="webcam_design" autoPlay capture={true} imageSmoothing
                                                        audio={false}
                                                        ref={webcamRef}
                                                        screenshotFormat="image/jpeg" />
                                                }

                                                {/* {
                                                    (img || state.visitor_picture) ?
                                                        <img style={{ width: "167px", height: "167px" }} src={img ? img : (state.visitor_picture ? state.visitor_picture : defaultImg)} alt="" />
                                                        :
                                                        <Webcam style={{ width: "167px", height: "167px", borderRadius: "50%", objectFit: "cover", "border": "1px solid #5473ff" }}
                                                            audio={false} ref={webcamRef}
                                                            screenshotFormat="image/jpeg" />

                                                } */}

                                                <div className="profile_camera dropdown">

                                                    <i className="fa fa-camera" aria-hidden="true"></i>

                                                    <div className="dropdown-content">
                                                        <span onClick={handleClick} >Device Image</span>
                                                        <span hidden={state.visitor_picture ? true : false} onClick={state.visitor_picture ? '' : capture} >Capture</span>
                                                        <span hidden={state.visitor_picture ? false : true} onClick={state.visitor_picture ? secondCapture : ''} >Reset</span>
                                                    </div>
                                                </div>

                                            </div>
                                            <input ref={inputRef} type="file" accept="image/*" id="visitor_picture" name="visitor_picture" onChange={handleChangeFile} style={{ display: 'none' }} />


                                        </div>
                                        <div className="visitor_mid" style={{ textAlign: "center" }}>
                                            <span style={{ color: "red" }}>{visitorPictureErrors}</span>
                                        </div>


                                        <div className="visitor_mid">
                                            <CLabel htmlFor="visitor_name">Name <span style={{ color: "red" }}><b> *</b></span></CLabel>
                                            <CInput name="visitor_name" id="visitor_name" placeholder="Enter Name "
                                                value={state.visitor_name} onChange={handleChange} />
                                            <span style={{ color: "red" }}>{nameErrors}</span>
                                        </div>

                                        <div className="visitor_mid">
                                            <CLabel htmlFor="visitor_address">Address <span style={{ color: "red" }}><b> *</b></span> </CLabel>
                                            <CInput name="visitor_address" id="visitor_address" placeholder="Enter Address" value={state.visitor_address} onChange={handleChange} />
                                            <span style={{ color: "red" }}>{addressErrors}</span>
                                        </div>

                                        <div className="visitor_mid">
                                            <CLabel htmlFor="to_whom_meet">To Whom Meet <span style={{ color: "red" }}><b> *</b></span></CLabel>
                                            <CInput name="to_whom_meet" id="to_whom_meet" placeholder="Enter Name" value={state.to_whom_meet} onChange={handleChange} />
                                            <span style={{ color: "red" }}>{toWhomMeetErrors}</span>
                                        </div>

                                        <div className="visitor_mid">
                                            <CLabel htmlFor="purpose_id">Purpose <span style={{ color: "red" }}><b> *</b></span> </CLabel>
                                            <CSelect custom name="purpose_id" id="purpose_id" value={state.purpose_id}
                                                onChange={handleChangePurposeId}
                                            >
                                                <option value="0">Select Purpose</option>
                                                {masterData.visitorPurpose && masterData.visitorPurpose.map((purpose, index) => (
                                                    <option key={purpose.id} value={purpose.id}>{purpose.name}</option>
                                                ))}

                                            </CSelect>

                                            {
                                                state.purpose_id == "other" ?
                                                    <>
                                                        <br></br>
                                                        <CLabel disabled={(state.purpose_id == 'other') ? false : true} htmlFor="purpose_id">Other Purpose <span style={{ color: "red" }}><b> *</b></span> </CLabel>
                                                        <CInput name="other_purpose_id" id="other_purpose_id" placeholder="Enter Other Purpose" onChange={handleChange} />

                                                    </>
                                                    : ""
                                            }
                                            <span style={{ color: "red" }}>{purposeErrors}</span>
                                        </div>


                                        <CLabel htmlFor="phone_no">Phone No <span style={{ color: "red" }}><b> *</b></span></CLabel>

                                        <CInput name="phone_no" type='number' id="phone_no" placeholder="Enter Phone No"
                                            value={state.phone_no} onChange={handleChange} onKeyDown={(evt) => ["e", "E", "+", "-", "."].includes(evt.key) && evt.preventDefault()} />
                                        <span style={{ color: "red" }}>{phoneNoErrors}</span>
                                        <br></br>

                                        <br></br>
                                    </div>
                                    <div className="col-md-2"></div>
                                </div>
                            </div>
                        </div>

                        <div className="comp_off_inn">
                            <div className="row">
                                <div className="atten_sec1 col-12">


                                    <CButton className="cancel" style={{ marginRight: 10 }} onClick={() => {
                                        setAddVisitorModal(!addVisitorModal)
                                        setState(prevState => ({
                                            ...prevState,
                                            visitor_picture: '',
                                            visitor_name: '',
                                            visitor_address: '',
                                            to_whom_meet: '',
                                            purpose_id: '',
                                            other_purpose_id: '',
                                            phone_no: '',
                                        }))
                                        setImg('')
                                        setNameErrors('')
                                        setAddressErrors('')
                                        setToWhomMeetErrors('')
                                        setPurposeErrors('')
                                        setPhoneNoErrors('')
                                    }}>
                                        Cancel
                                    </CButton>
                                    <CButton className="save" onClick={ValidateForm} disabled={submitDisable ? true : false} >
                                        Submit
                                    </CButton>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal>


                <Modal
                    show={checkOutModal}
                    onHide={() => {
                        setSelectedVisitorId('')
                        setCheckOutModal(!checkOutModal)
                    }}
                    backdrop="static"
                >
                    <div className="apply_comp_sec">
                        <Modal.Header closeButton >
                            <h6 className="hed_txt">Check Out</h6>
                        </Modal.Header>

                        <div className="comp_inner_sec">
                            <div className="comp_off_inn">
                                <div className="row">
                                    <div className="col-md-12">
                                        <CLabel style={{ textAlign: 'center' }}>Do you want to check out?</CLabel>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="comp_off_inn">
                            <div className="row">
                                <div className="atten_sec1 col-12">
                                    <CButton className="cancel" style={{ marginRight: 10 }} onClick={() => {
                                        setSelectedVisitorId('')
                                        setCheckOutModal(!checkOutModal)
                                    }
                                    }>
                                        No
                                    </CButton>
                                    <CButton className="save"

                                        onClick={(e) => visitorTimeOutSubmitClick(e)}
                                    >
                                        Yes
                                    </CButton>

                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>


                <Modal
                    show={fileViewer}
                    onHide={closeFileViewerModal}
                    backdrop="static"
                >
                    <div className="apply_comp_sec">
                        <Modal.Header closeButton >
                            <h6 className="hed_txt">{state.selected_visitor_name}'s Image</h6>
                        </Modal.Header>
                        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>

                            <img width="100%" src={state.visitor_picture_view}
                                alt={state.selected_visitor_name} title={state.selected_visitor_name}
                            />

                        </div>
                    </div>
                </Modal>

            </CRow>
        </>
    )
}
export default VisitorManagement
